import { isValidDomain, parseDomain } from '@wix/domains-serverless-interface';
export const isExactDomainQuery = query => isValidDomain(query) && Boolean(parseDomain(query).sld);
export const withTld = function (query, tld, replaceable) {
  if (replaceable === void 0) {
    replaceable = [];
  }
  const lowered = query.toLowerCase();
  const {
    tld: parsedTld
  } = parseDomain(query);
  const candidates = [...new Set([tld, parsedTld, ...replaceable])].filter(candidate => Boolean(candidate)).sort((a, b) => b.length - a.length);
  const applied = candidates.find(candidate => lowered.endsWith(`.${candidate.toLowerCase()}`));
  const base = applied ? query.slice(0, -(applied.length + 1)) : query;
  return `${base}.${tld}`;
};
export const buildDomainWithTld = (query, tld) => {
  const {
    sld
  } = parseDomain(query);
  if (!sld) {
    return null;
  }
  const domain = `${sld}.${tld}`;
  return isValidDomain(domain) ? domain : null;
};
//# sourceMappingURL=tldQuery.js.map